// Vendors
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useProofIncomeContextConsumerHook } from 'containers/proof-income/contexts/proof-income.context';
import { useStylesContextConsumerHook } from 'contexts/styles.context';
// Constants
import { POI_POLLING_TIME_PROPS } from './constants/proof-income-method.hook.constants';
// Event Handlers
import { ProofIncomeMethodHandlers } from '../handlers/proof-income-method.handlers';
// Hooks
import { useAppGetStateHook } from 'hooks/get-state.hook';
// Types
import { ProofIncomeMethodHookType } from './types/proof-income-method.hook.type';
// Utils
import { isTGSSSelectedMethod } from '../handlers/utils/proof-income-method.handlers.utils';

const useProofIncomeMethodHook = (): ProofIncomeMethodHookType => {
  const [height, setHeight] = useState(0);

  const { iframeUrl, proofIncomeIdentificationId, selectedMethod, setProofIncomeState } =
      useProofIncomeContextConsumerHook(),
    { setCurrentState, setOnHeaderBackClick } = useAppContextConsumerHook(),
    { setPaddingContent } = useStylesContextConsumerHook();

  const { showBoundary: setError } = useErrorBoundary();

  const {
      handleToggleEntrypointCenterPaddingEvent,
      handleUpdateProofIncomeHeaderBackClickHandler,
      handleManageReceivedDataFromWSEvent: onSuccess,
      handleOnPOIPollingError: onError,
      ...handlers
    } = ProofIncomeMethodHandlers({
      proofIncomeIdentificationId,
      selectedMethod,
      setCurrentState,
      setError,
      setHeight,
      setPaddingContent,
      setProofIncomeState,
    }),
    { handleGetOnboardingStateEvent } = useAppGetStateHook({
      ...POI_POLLING_TIME_PROPS,
      onError,
      onSuccess,
    });

  useEffect(() => {
    handleToggleEntrypointCenterPaddingEvent(false);

    setOnHeaderBackClick(() => handleUpdateProofIncomeHeaderBackClickHandler);
    isTGSSSelectedMethod(selectedMethod) && handleGetOnboardingStateEvent();

    return () => {
      handleToggleEntrypointCenterPaddingEvent(true);
      setOnHeaderBackClick(null);
    };
  }, []);

  return {
    ...handlers,
    height,
    iframeUrl,
    selectedMethod,
  };
};

export { useProofIncomeMethodHook };
